import { Key, useEffect } from 'react'

import { MONITORING_PRODUCT_STATUS } from '@app/api/constants'

import { useToggle } from '@app/hooks'

import type { RegistryCurrentListDataSource } from '@app/pages/RegistryPageInner/types'
import type { UseToggleToolbarButtonsReturn } from './types'

export const useToggleCurrentToolbarButtons = (
  selectedKeys: Key[],
  selectedRecords: RegistryCurrentListDataSource[]
): UseToggleToolbarButtonsReturn => {
  const deleteButtonToggle = useToggle()
  const restoreButtonToggle = useToggle()

  const handleUnselectToolbarSelectedButtons = (): void => {
    deleteButtonToggle.setUntoggled()
    restoreButtonToggle.setUntoggled()
  }

  const handleToggleButtons = (): void => {
    const selectedCount = selectedKeys.length
    const selectedOne = selectedCount === 1
    const selectedMoreThanOne = selectedCount > 1
    const selectedStatuses = selectedRecords.map(record => record.status)
    const selectedHasDeleted = selectedStatuses.includes(MONITORING_PRODUCT_STATUS.DELETED)
    const selectedOnlyDeleted = selectedStatuses.every(status => status === MONITORING_PRODUCT_STATUS.DELETED)

    if (!selectedCount) {
      restoreButtonToggle.setUntoggled()
      deleteButtonToggle.setUntoggled()
      return
    }

    if (selectedOne && selectedHasDeleted) {
      restoreButtonToggle.setToggled()
      deleteButtonToggle.setUntoggled()
      return
    }

    if (selectedOne && !selectedHasDeleted) {
      restoreButtonToggle.setUntoggled()
      deleteButtonToggle.setToggled()
      return
    }

    if (selectedMoreThanOne && selectedOnlyDeleted) {
      restoreButtonToggle.setToggled()
      deleteButtonToggle.setUntoggled()
      return
    }

    if (selectedMoreThanOne && selectedHasDeleted) {
      restoreButtonToggle.setToggled()
      deleteButtonToggle.setToggled()
      return
    }

    if (selectedMoreThanOne && !selectedOnlyDeleted) {
      deleteButtonToggle.setToggled()
      restoreButtonToggle.setUntoggled()
    }
  }

  useEffect(() => {
    handleToggleButtons()
  }, [selectedKeys])

  return {
    deleteButtonToggle,
    restoreButtonToggle,
    handleUnselectToolbarSelectedButtons
  }
}
